/*
 * @Author: liyxt
 * @Date: 2020-06-16 10:57:18
 * @LastEditors: liyxt
 * @LastEditTime: 2020-07-02 15:51:50
 * @Description: file content
 */ 
/*
* 展示年月日， 返回选中日期的开始第一秒和结束最后一秒（用下滑杠拼接）， '2019-02-05 00:00:00_2019-02-05 23:59:59'
*
* */

import React, { Component } from 'react';
import DatePickerClientS from '../DatePickerTimeZoneConversion';
require('./index.less');

export default class TZDatePickerRangeDay extends Component {
    render() {
        let {
            className,
            format = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY.MM.DD', 'YYYY/MM/DD'],
            ...others
        } = this.props;
        return (
            <DatePickerClientS
                {...others}
                format={format}
                MultiTZ={true}
                isRangDay={true}
                className={`TZDatePickerRangeDay ${className}`}
            />
        );
    }
}
TZDatePickerRangeDay.defaultProps = {
    // showTime: true,
    showClear: true,
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
};
